import { persist, type PersistStorage } from "zustand/middleware";
import { create } from "zustand";
import Cookies from "js-cookie";
import { Storage } from "@/shared/constants/storage";

const cookieStorage: PersistStorage<any> = {
  getItem: (name) => {
    const cookie = Cookies.get(name);
    return cookie ? JSON.parse(cookie) : null;
  },
  setItem: (name, value) => {
    Cookies.set(name, JSON.stringify(value), {
      secure: false,
      sameSite: "Lax",
    });
  },
  removeItem: (name) => {
    Cookies.remove(name);
  },
};
type AuthState = {
  accessToken: string;
  refreshToken: string;
};
type AuthAction = {
  setAccessToken: (accessToken: string) => void;
  setRefreshToken: (refreshToken: string) => void;
  clearAuthStore: () => void;
};
const initialAuth: AuthState = {
  accessToken: "",
  refreshToken: "",
};

export const useAuthStore = create<AuthState & AuthAction>()(
  persist(
    (set) => ({
      ...initialAuth,
      setAccessToken: (accessToken: string) => {
        set({ accessToken });
      },
      setRefreshToken: (refreshToken: string) => {
        set({ refreshToken });
      },
      clearAuthStore: () => {
        set({ ...initialAuth });
        cookieStorage.removeItem(Storage.auth);
      },
    }),
    {
      name: Storage.auth,
      storage: cookieStorage,
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
      }),
    }
  )
);
